import React from 'react';

const SocialIcon = ({ href, label, children, colorClass }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className={`${colorClass} hover:opacity-70 transition-opacity p-1`}
    aria-label={label}
  >
    {children}
  </a>
);

export default SocialIcon;

